export enum CouponApplyOnEnum {
  simBooking = "simBooking",
  recharge = "recharge",
}

export type CouponCheckApplicabilityProps = {
  DATA: {
    couponCode: string;
    amount: string | number;
    applyOn: CouponApplyOnEnum;
  };
};
